(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};



      this.setHeaderHeight();



      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));



      if (this.headerIsAlwaysSticky) {

        this.header.classList.add('shopify-section-header-sticky');

      };



      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

    }



    setHeaderHeight() {

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }



    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }



    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach(disclosure => disclosure.close());

    }



    closeSearchModal() {

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      this.searchModal.close(false);

    }

  }



  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ts-collection-tabs')) {
  customElements.define('ts-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', e => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault(); const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(n); this.tabs[n].focus();
          }
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, j) => {
        const on = i === j; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        const p = this.querySelector('#' + t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-hero-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ts-hero-banners')) {
  customElements.define('ts-hero-banners', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ts-hb__track');
      this.slides = [...this.track.children];
      const dots = this.querySelector('.ts-hb__dots');
      if (this.slides.length < 2) { this.querySelector('.ts-hb__nav').hidden = true; return; }
      this.dots = this.slides.map((s, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'ts-hb__dot'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `${i + 1}枚目`); b.addEventListener('click', () => this.go(i, true)); dots.appendChild(b); return b;
      });
      this.querySelectorAll('.ts-hb__arrow').forEach(a => a.addEventListener('click', () => this.go(this.idx + Number(a.dataset.dir), true)));
      this.idx = 0; this.mark();
      this.track.addEventListener('scroll', () => { clearTimeout(this.st); this.st = setTimeout(() => {
        this.idx = Math.round(this.track.scrollLeft / this.track.clientWidth); this.mark(); }, 80); }, { passive: true });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const ms = Number(this.dataset.interval) || 6000;
      if (!reduce) { this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.idx + 1); }, ms); }
      ['mouseenter', 'focusin', 'touchstart'].forEach(e => this.addEventListener(e, () => (this.paused = true), { passive: true }));
      ['mouseleave', 'focusout'].forEach(e => this.addEventListener(e, () => (this.paused = false)));
    }
    go(i, user) {
      const n = this.slides.length; this.idx = (i + n) % n;
      this.track.scrollTo({ left: this.idx * this.track.clientWidth });
      this.mark(); if (user) this.paused = true;
    }
    mark() { (this.dots || []).forEach((d, i) => d.setAttribute('aria-selected', i === this.idx ? 'true' : 'false')); }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
